<template>
  <portal to="validationmessages">
    <div class="XVValidation" v-if="errors.count() && getvalidationMessageStatus">
      <span id="grittgroupgritter-default">
        <div class="groepsluiten" groep="gritter-warning">
          <div class="groepheader gritter-warning">
            <span
              class="glyphicon glyphicon-remove"
              @click="setvalidationMessageStatus(false)"
              aria-hidden="true"
            ></span>
            <span class="gritterheadertitle">{{ translation(12399) }}</span>
          </div>
          <div class="gritter-item-wrapper gritter-warning" style role="alert">
            <div v-for="(error, index2) in errors" :key="index2">
              <div class="gritter-top"></div>
              <div class="gritter-item">
                <div class="gritter-without-image">
                  <a :href="'#' + error.field">{{ error.msg }}</a>
                </div>
                <div style="clear: both"></div>
              </div>
              <div class="gritter-bottom"></div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </portal>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'XVvalidationMessage',
  inject: ['$validator'], // dit doe ik om de validators te triggeren van de dynamische input, zodat bij validatie hoofdniveau de onderliggende ook afgaan
  computed: {
    ...mapGetters(['getvalidationMessageStatus']),
  },
  methods: {
    ...mapMutations(['setvalidationMessageStatus']),
  },
}
</script>
<style scoped>
.XVValidation .gritter-warning a {
  color: black;
}
</style>
